// Selects
import CNAEFirstSelect from './selects/CNAE-first-select.vue';
import QualifiedLeadsPrimaryCnaeSelect from './selects/qualified-leads-primary-cnae-select.vue';
import MunicipioSelect from './selects/municipio-select.vue';
import QualifiedLeadsCitySelect from './selects/qualified-leads-city-select.vue';
import QualificationSelect from './selects/qualification-select.vue';
import AddLeadCitySelect from './selects/add-lead-city-select.vue';
import SCEEPowerSelect from './selects/scee-power-select.vue';
import LeadsExtractedSelect from './selects/leads-extracted-select.vue';
import ResponsibleUserSelect from './selects/responsible-user-select.vue';

// Tables
import LeadsTable from './tables/leads-table.vue';
import QualifiedLeadsTable from './tables/qualified-leads-table.vue';
import LeadsReportTable from './tables/leads-report-table.vue';

//Modals
import EditLeadDetailsModal from './modals/edit-lead-details-modal.vue';

export {
  // Selects
  CNAEFirstSelect,
  QualifiedLeadsPrimaryCnaeSelect,
  MunicipioSelect,
  QualifiedLeadsCitySelect,
  QualificationSelect,
  AddLeadCitySelect,
  SCEEPowerSelect,
  LeadsExtractedSelect,
  ResponsibleUserSelect,
  //Modals
  EditLeadDetailsModal,
  //Tables
  LeadsTable,
  QualifiedLeadsTable,
  LeadsReportTable,
};
